// @ts-strict-ignore
import React from "react";
import NextLink from "../NextLink";
import { PostContainer, PostTitle, PostSubtitle } from "./style";
import { getShortenedTextWithEllipsis } from "utils/cryptopedia";
import { contentfulLoaderSterile } from "utils/images/contentfulLoader";
import NextImage from "../NextImage";

const Post = ({ img, title, subtitle, slug, subtitleLength = 160 }) => {
  const [activeHover, setActiveHover] = React.useState(false);

  return (
    <PostContainer
      onMouseEnter={() => setActiveHover(true)}
      onMouseLeave={() => setActiveHover(false)}
    >
      <NextLink href={`/cryptopedia/${slug}`}>
        <NextImage src={img} alt={title} loader={contentfulLoaderSterile} />
        <PostTitle bold active={activeHover}>
          {title}
        </PostTitle>
        <PostSubtitle>
          {getShortenedTextWithEllipsis(subtitle, subtitleLength)}
        </PostSubtitle>
      </NextLink>
    </PostContainer>
  );
};

export default Post;
